export type ParsedPlaceAddress = {
  address1: string;
  city: string;
  state: string;
  zip: string;
  country: string;
};

type AddressComponent = {
  long_name: string;
  short_name: string;
  types: string[];
};

/**
 * Maps Google Places address_components into the flat address fields used
 * across Omni (address1 / city / state / zip / country).
 */
export const parseGooglePlaceAddress = (
  components: AddressComponent[] | null | undefined,
): ParsedPlaceAddress => {
  const empty: ParsedPlaceAddress = {
    address1: '',
    city: '',
    state: '',
    zip: '',
    country: '',
  };
  if (!components?.length) {
    return empty;
  }

  const get = (type: string, short = false): string => {
    const match = components.find((c) => (c.types || []).includes(type));
    if (!match) return '';
    return short ? match.short_name : match.long_name;
  };

  const streetNumber = get('street_number');
  const route = get('route');
  const address1 = [streetNumber, route].filter(Boolean).join(' ').trim();
  const city = get('locality')
    || get('postal_town')
    || get('sublocality_level_1')
    || get('sublocality')
    || get('neighborhood')
    || get('administrative_area_level_2');
  const state = get('administrative_area_level_1', true);
  const zip = get('postal_code');
  const country = get('country', true);

  return { address1, city, state, zip, country };
};
